import React from 'react'
import { Typography } from '@mui/material'

const ErrorText = ({reason}) => {
  return (
    <div>
      <Typography variant="h5" textAlign="center">Something went wrong!</Typography>
      <Typography variant="body2" textAlign="center">{reason}</Typography>
    </div>
  )
}

export default ErrorText;
